import Index from "./requestLeadTime.vue";
import Detail from "./requestLeadTimeDetail.vue";

let routesRequestMuat = [
    {
      path: '',
      meta: {
        title: "Chain System",
      },
      name: "requestLeadTime",
      component: Index
    },
    {
      path: 'detail/:id',
      meta: {
        title: "Chain System",
      },
      name: "requestLeadTimeDetail",
      component: Detail
    },
    
   
]

export default routesRequestMuat
  